import StepHeader from '../../components/Wizard/StepHeader';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';

const FAQ_URL = 'https://www.sbt.com.br/faq';

export default function SocialConnectionError() {
  function redirectToFaq() {
    window.location.href = FAQ_URL;
  }

  function tryAgain() {
    window.location.href = '/signup';
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Não foi dessa vez"
          description={[
            'Algo deu errado e não foi possível criar sua Conta SBT.',
            'Você pode tentar novamente ou escolher um método diferente.',
            'Caso o problema persista, entre em contato com a gente e informe o seguinte código:'
          ]}
        />
      </div>

      <div className="button-group">
        <Button
          id="social-try-again"
          customColors="btn-primary"
          onClick={tryAgain}
        >
          <ButtonLabel>Tentar novamente</ButtonLabel>
        </Button>

        <Button
          id="social-error-help"
          customColors="btn-ghost"
          onClick={redirectToFaq}
        >
          <ButtonLabel>Entrar em contato</ButtonLabel>
        </Button>
      </div>
    </div>
  );
}
